import { X } from 'lucide-react';
import "./ConfirmDelete.scss";
import { useRef } from 'react';
import { useClickOutside } from '@/utils';

type Props = {
    type: "Invoice" | "Customer" | "Transaction";
    action: "Delete" | "Archive"
    id?: string;
    count?: number;
    onClose: () => void;
    onDelete: () => void;
}
export const ConfirmDelete = ({ type, id, count, action, onClose, onDelete }: Props) => {
    const areaRef = useRef<HTMLDivElement>(null);
    useClickOutside(areaRef, onClose);

    return <div className="delete" ref={areaRef}>
        <button className="delete__close" onClick={onClose}>
            <X width={18} height={18} />
        </button>

        <h2>{action} this {type.toLowerCase()}</h2>
        <div className="delete__container">
            {!count ?
                <p> Are you sure you want to {action.toLowerCase()} {type.toLowerCase()} {id}?</p> :
                <p> Are you sure you want to {action.toLowerCase()} {count} {type.toLowerCase()}s?</p>}
        </div>

        <div className="delete__buttons">
            <button className='delete__cancel' onClick={onClose}>Cancel</button>
            <button className='delete__delete' onClick={async () => {

                await onDelete();
                onClose();
            }}>
                {action}
            </button>
        </div>
    </div>
}